// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_in_store = /** @type {(inputs: {}) => string} */ () => {
	return `In Store`
};

const el_in_store = /** @type {(inputs: {}) => string} */ () => {
	return `Στο Κατάστημα`
};

const ru_in_store = /** @type {(inputs: {}) => string} */ () => {
	return `В магазине`
};

const he_in_store = /** @type {(inputs: {}) => string} */ () => {
	return `בחנות`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const in_store = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.in_store(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("in_store", locale)
	if (locale === "en") return en_in_store(inputs)
	if (locale === "el") return el_in_store(inputs)
	if (locale === "ru") return ru_in_store(inputs)
	if (locale === "he") return he_in_store(inputs)
	return "in_store"
};